import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./Navbar.module.css";

export default function Navbar() {
  const location = useLocation();
  const nav = useNavigate();

  const user = JSON.parse(localStorage.getItem("bni_user") || "null");
  const token = localStorage.getItem("bni_token");

  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const API = process.env.REACT_APP_API_URL || "http://localhost:8080";

  const dropdownRef = useRef<any>(null);

  useEffect(() => {
    const close = (e: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  const logout = () => {
    localStorage.removeItem("bni_token");
    localStorage.removeItem("bni_user");
    nav("/");
    window.location.reload();
  };

  const navItems = [
    { name: "Home", to: "/" },
    { name: "Members", to: "/members" },
    // { name: "Statistics", to: "/stats" },
    { name: "About", to: "/about" },
  ];

  const editMemberLink = user?._id
    ? `/members/edit/${user.memberId || user._id}`
    : "/profile";

  return (
    <header className={styles.navbar}>
      <div className={styles.wrapper}>
        {/* ✅ BRAND */}
        <div className={styles.brandArea} onClick={() => nav("/")}>
          <div className={styles.brandTextBlock}>
            <img
              src="/images/bniWhiteLogo.png"
              alt="BNI"
              className={styles.bniLogo}
            />
          </div>
        </div>

        {/* ✅ MOBILE HAMBURGER */}
        <button
          className={styles.hamburger}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className={menuOpen ? styles.barOpen : styles.bar}></span>
          <span className={menuOpen ? styles.barOpen : styles.bar}></span>
          <span className={menuOpen ? styles.barOpen : styles.bar}></span>
        </button>

        {/* ✅ NAVIGATION */}
        <nav className={`${styles.navLinks} ${menuOpen ? styles.navOpen : ""}`}>
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={() => setMenuOpen(false)}
              className={
                location.pathname === item.to
                  ? styles.activeLink
                  : styles.navLink
              }
            >
              {item.name}
            </Link>
          ))}

          {/* ✅ IF NOT LOGGED */}
          {!token && (
            <Link
              className={`${styles.navLink} ${styles.loginBtn}`}
              to="/auth/login"
            >
              Login
            </Link>
          )}

          {/* ✅ LOGGED IN USER */}
          {token && user && (
            <div className={styles.userSection} ref={dropdownRef}>
              <div
                className={styles.userBubble}
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                <img src="/images/bniWhiteLogo.png" alt="BNI" />
              </div>

              {dropdownOpen && (
                <div className={styles.dropdownMenu}>
                  {/* ✅ SUPER ADMIN ONLY */}
                  {user?.role === "SUPER_ADMIN" && (
                    <Link
                      to="/admin"
                      onClick={() => setDropdownOpen(false)}
                      className={styles.dropdownItem}
                    >
                      Admin Panel
                    </Link>
                  )}

                  <button className={styles.dropdownItem} onClick={logout}>
                    Logout
                  </button>
                </div>
              )}
            </div>
          )}
        </nav>
      </div>
    </header>
  );
}
